import React from 'react';

const VideoSection: React.FC = () => {
  // Extract video ID from the shorts URL
  const videoId = 'QsN5gvjZauk';
  const youtubeChannelUrl = 'https://www.youtube.com/@mintorepair';
  const instagramUrl = 'https://www.instagram.com/minto_repairs/';

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6">
      <div className="px-4 py-3 border-b border-gray-100">
        <h3 className="text-base font-medium text-gray-800">Watch How It Works</h3>
      </div>
      <div className="p-4">
        <div className="relative w-full max-w-[400px] mx-auto">
          <div className="video-container" style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
            <iframe 
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              src={`https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0&modestbranding=1`}
              title="Mobile Repair Service"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
              className="rounded-xl"
            ></iframe>
          </div>
          {/* Video description */}
          <div className="mt-4 text-center">
            <h4 className="text-sm font-medium text-gray-900">Quick Mobile Repair Service</h4>
            <p className="text-xs text-gray-500 mt-1">Watch how we repair your device at your doorstep</p>
            
            {/* Social Media Links */}
            <div className="mt-4 flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href={youtubeChannelUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-2 bg-red-600 text-white rounded-full hover:bg-red-700 transition-colors shadow-sm hover:shadow-md"
              >
                <i className="fab fa-youtube text-lg"></i>
                <span className="font-medium">Subscribe</span>
              </a>
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full hover:from-purple-600 hover:to-pink-600 transition-all shadow-sm hover:shadow-md"
              >
                <i className="fab fa-instagram text-lg"></i>
                <span className="font-medium">Follow Us</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoSection; 